const subDomainReducer = (state = {}, action) => {
  switch (action.type) {
    case "SUBDOMAIN":
      return action.payload;
    default:
      return state;
  }
};

export default subDomainReducer;
